import { render, staticRenderFns } from "./UsuarioLogado.vue?vue&type=template&id=d08764a4&"
import script from "./UsuarioLogado.vue?vue&type=script&lang=js&"
export * from "./UsuarioLogado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports